<template>
  <div>
    <div class="wrapper">
      <v-switch
        @change="onSwitchChange($event)"
        :disabled="disabled"
        :input-value="status"
        :label="label"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppInactiveSwitch',
  props: {
    status: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      if (!this.withLabel) return null
      return this.status ? '有効' : '無効'
    },
  },
  methods: {
    onSwitchChange(active) {
      this.$emit('change', !!active)
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
::v-deep .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-input—selection-controls__input {
  height: 0;
}
::v-deep .v-input—selection-controls {
  margin-top: 0;
  padding-top: 0;
}

::v-deep .v-messages {
  min-height: 0;
}

::v-deep .v-label {
  font-size: 14px;
}
</style>
